<template>

<router-link :to="{name: to}" class="item" :class="{'is-active': active}">

	{{ text }}

</router-link>

</template>

<script>

export default {

	props: ['text', 'to'],

	computed: {

		active: function() {

			return this.$route.name === this.to || this.$route.meta.default === this.to

		}

	}

}

</script>

<style scoped>

.item {
	display: block;
	width: 100%;
    color: var(--color-grey-dark);
    font-size: 14px;
    line-height: 20px;
    padding: 5px 10px;
    font-weight: 400;
    flex-grow: 1;
}

.item.is-active {
	color: var(--color-blue-light);
}

.is-desktop .item:hover {
	background-color: var(--color-grey-light);
}

</style>